@if (institutionId > 0) {
  <div id="submodule-discounts" class="cw-module-card">
    <div class="cw-flex-row">
      <h2>{{ 'MODULES.INSTITUTIONS.DISCOUNTS.HEADER' | translate }}</h2>
    </div>
    <phscw-grid
      #gridInstitutionsDiscounts
      [gridId]="gridId"
      [simpleGrid]="true"
      [gridData]="data"
      [gridColumns]="gridColumns"
      [gridDisplayedColumns]="gridDisplayedColumns"
      [sortableHeader]="true">
    </phscw-grid>
    <phscw-grid-load-more
      [gridId]="gridId"
      [enabled]="loadMoreEnabled"
      [visible]="loadMoreVisible"
      [gridPageCounter]="gridPage"
      [loadAllButton]="true">
    </phscw-grid-load-more>
  </div>
}
